import { Component, ChangeDetectorRef, ViewChild } from '@angular/core'
import { IFilterParams, IDoesFilterPassParams } from 'ag-grid-community'
import { AgFilterComponent } from 'ag-grid-angular'
import { Option } from '../../../app-select/option'
import { AppSelectComponent } from '../../../app-select/app-select.component'

interface IExtendedFilterParams extends IFilterParams {
  placeholderText: string
}

@Component({
  selector: 'app-multilookup-filter',
  templateUrl: './multilookup-filter.component.html',
  standalone: false
})
export class MultiLookupFilterComponent implements AgFilterComponent {
  public params: IFilterParams
  public placeholderText: string

  @ViewChild('multilookupFilter', { static: true })
  multilookupFilter: AppSelectComponent

  public items: Option[] = []

  private _selectedItems: string[] | number[] = []

  private _cachedModel: any = null

  public get selectedItems(): string[] | number[] {
    return this._selectedItems
  }
  public set selectedItems(value: string[] | number[]) {
    this._selectedItems = value
    this.params.filterChangedCallback()
  }

  constructor(private cdr: ChangeDetectorRef) {}

  agInit(params: IExtendedFilterParams): void {
    this.params = params
    this.placeholderText = params.placeholderText || ''
  }

  setItems(items: Option[]): void {
    this.items = items

    if (this._cachedModel) {
      this.setModel(this._cachedModel)
      this._cachedModel = null
      this.params.filterChangedCallback()
    }

    this.cdr.detectChanges()
  }

  isFilterActive(): boolean {
    return !!this.selectedItems && this.selectedItems.length > 0
  }

  doesFilterPass(_params: IDoesFilterPassParams): boolean {
    // We repull the data when we enter the multi select here. There is no reason for bad data to be here.
    return true
  }

  getModel(): any {
    return this.isFilterActive()
      ? { type: 'in', filter: this.selectedItems.map(x => x).join(', ') }
      : null
  }

  setModel(model: any): void {
    if (this.items.length === 0) {
      this._cachedModel = model
      return
    }

    if ((model || {}).filter) {
      const items = this.items.filter(x => x.id.toString() === model.filter.toString())
      if (items.length > 0) {
        this._selectedItems = items.map(item => item.id) as any
        return
      }
    }

    this._selectedItems = null
  }

  onSelect = () => {
    this.selectedItems = this.multilookupFilter.active.map((_: any) => _.value.id) || null
  }
}
